import { APIGetRequest } from '@ancon/wildcat-types'

import Request from '../../client/Request'
import { APIType } from '../../types'
import endpoints from '../endpoints'
import { GuestAvailability, GuestWidget } from '../../../features/booking/types'

type WidgetsAPI = {
  get: {
    byKey: APIGetRequest<GuestWidget, { widgetKey: string }>
    /** The outlet's published booking page, found by Core ids */
    byOutlet: APIGetRequest<GuestWidget, { tenantId: string; outletId: string }>
    availability: APIGetRequest<
      GuestAvailability,
      {
        widgetKey: string
        bookingTypeId: string
        businessDate: string
        partySize: number
      }
    >
  }
}

const widgets: WidgetsAPI = {
  get: {
    byKey: new Request(endpoints.reservation.widgets.byKey.list, {
      apiType: APIType.Reservation,
    }).get,
    byOutlet: new Request(
      endpoints.reservation.tenants.byId.outlets.byId.widget.list,
      {
        apiType: APIType.Reservation,
      },
    ).get,
    availability: new Request(
      endpoints.reservation.widgets.byKey.availability.list,
      {
        apiType: APIType.Reservation,
      },
    ).get,
  },
}

export default widgets
